import { forwardRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@elfsight/lib-icon';
import type { BaseButtonProps } from '../buttons';
import { BaseButton } from '../buttons';

export type TagIconButtonProps = Omit<
  BaseButtonProps,
  'rightSlot' | 'leftSlot'
> & {
  iconSrc?: string;
};

export const TagIconButton = forwardRef<HTMLButtonElement, TagIconButtonProps>(
  (
    { children, iconSrc, borderRadius = 32, ...forwardingProps },
    forwardingRef
  ) => {
    return (
      <Button
        {...forwardingProps}
        borderRadius={borderRadius}
        leftSlot={
          iconSrc ? (
            <Icon size={20} src={iconSrc} fill="currentColor" alt="" />
          ) : undefined
        }
        ref={forwardingRef}
        withOverflow
      >
        {children}
      </Button>
    );
  }
);

const Button = styled(BaseButton)`
  max-width: 260px;
  &:active {
    transform: scale(0.9);
  }
`;
